module.exports = __webpack_public_path__ + "static/media/logo-lotto535.a6bde056.png";